import { Store } from "vuex";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import MerchantFlags from "@/apps/merchant3/types/MerchantFlags";

export const merchantHasUseAddOnServicesFlag = (): boolean => {
  const vuexStore = store as unknown as Store<IVuexState>;

  return vuexStore.state.merchant?.merchantFlags?.includes(
    MerchantFlags.USE_ADD_ON_SERVICES
  );
};
